module.exports = __webpack_public_path__ + "fonts/iconfont.9514e0ee.woff2";